/**
 * about staffのモーダル
 */
import Vue from 'vue/dist/vue.min.js'
import PerfectScrollbar from 'perfect-scrollbar';
import ResizeWatch from '../utils/ResizeWatch';
import AnyStore from "../common/AnyStore";

export default class modalStaff {
  /**
   * コンストラクタ
   */
  constructor() {
    // クラス名
    this.name = 'modalStaff';
    this.presentWidth = window.innerWidth;

    if (document.getElementById('js-param-staff')) {
      this.init();
    }
  }

  /**
   * 表示前
   */
  init() {
    // staffリンク
    Vue.component('modal-staff', {
      data: function() {
        return {
          isShow: false
        }
      },
      methods: {
        getPersonImg: function(imgFile) {
          return `/manage/wp-content/themes/aas/assets/img/about/member/${imgFile}`;
        },
        openModal: function() {
          this.isShow = true;

          this.$nextTick(() => {
            if (AnyStore.getWindowWidth() > 900) {
              // pc
              this.$refs.staffDown.style.height = '';
            } else {
              // sp
              const staffH1 =  $(this.$refs.staffUp).outerHeight(true);
              const staffH2 = $(this.$refs.staffDown).outerHeight(true);

              if (staffH1 + staffH2 < window.innerHeight) {
                // 高さ入れる
                this.$refs.staffDown.style.height = (window.innerHeight - staffH1) + 'px';
              }
            }

            // スクロールバー
            this.ps = new PerfectScrollbar(this.$el, {
              suppressScrollX: true
            });
          });
        },
        closeModal: function() {
          this.isShow = false;

          this.ps.destroy();
          this.ps = null;

          this.$refs.staffDown.style.height = '';

          this.$emit('close');
        },
        resize() {
          if (this.isShow) this.closeModal();
        }
      },
      props: ['person'],
      template: '<transition name="staff-modal"><div v-show="isShow" class="p-staff-modal">\n' +
        '  <div ref="staffUp" class="p-staff-modal__col">\n' +
        '    <p class="col-title" itemprop="jobTitle">\n' +
        '      <span class="col-title__en" lang="en" v-html="person.job_en"></span>\n' +
        '      <span class="col-title__ja" v-html="person.job_ja"></span>\n' +
        '    </p>\n' +
        '    <figure v-if="person.image" class="col-photo">\n' +
        '      <img :src="getPersonImg(person.image)" :alt="person.name" itemprop="image">\n' +
        '    </figure>\n' +
        '    <h4 class="col-name" itemprop="name">{{person.name}}</h4>\n' +
        '  </div>\n' +
        '  <div ref="staffDown" class="p-staff-modal__col">\n' +
        '    <dl class="col-profile">\n' +
        '      <dt>Profile</dt>\n' +
        '      <dd v-html="person.message"></dd>\n' +
        '    </dl>\n' +
        '  </div>\n' +
        '  <div class="btn-close" @click="closeModal">\n' +
        '    <div class="btn-close__wrap"></div>\n' +
        '  </div>\n' +
        '</div></transition>\n'
    });

    // staffモーダルを生成
    this.vueModal = new Vue({
      el: '#vue-modal-staff',
      data: {
        preventScroll: 0,
        person: {},
        staff: []
      },
      methods: {
        openModal: function(div, id) {
          // bodyにclassを追加
          TweenMax.set(document.body, {className: '+=is-open-gnav'});
          this.person = this.staff[div].list[id];
          this.$refs.modalStaff.openModal();

          requestAnimationFrame(this.openRequest.bind(this));
        },
        closeModal: function() {
          // bodyのclassを削除
          TweenMax.set(document.body, {className: '-=is-open-gnav'});

          requestAnimationFrame(this.closeRequest.bind(this));
        },
        openRequest: function() {
          if (Useragnt.ios) {
            // モーダルが開いたら、bodyにfixedを付与
            this.preventScroll = AnyStore.getScrollTop();
            document.body.style.top = `-${this.preventScroll}px`;
            document.body.style.position = 'fixed';
          }
        },
        closeRequest: function() {
          if (Useragnt.ios) {
            // モーダルが開いたら、bodyにfixedを付与
            document.body.style.position = 'static';
            document.body.style.top = '';
            window.scrollTo(0, this.preventScroll);
          }
        },
        resize() {
          this.$refs.modalStaff.resize();
        }
      },
      created: function() {
        const staff = JSON.parse(document.getElementById('js-param-staff').textContent);
        this.staff = staff[0];
      },
      mounted: function() {
        // vueの準備完了
      }
    });

    document.querySelectorAll('.p-about-staff__list-item').forEach((el, index) => {
      el.addEventListener('click', this.openModal.bind(this, [
        el.getAttribute('data-division'),
        el.getAttribute('data-id')
      ]));
    });

    ResizeWatch.registerObserver(this.name, this);
  }

  /**
   * 表示時
   */
  start() {

  }

  /**
   * モーダル開く
   */
  openModal(data, e) {
    this.vueModal.openModal(data[0], data[1]);
  }

  /**
   * ウィンドウリサイズ
   */
  resizeUpdate() {
    if (window.innerWidth != this.presentWidth) {
      this.vueModal.resize();
    }
    this.presentWidth = window.innerWidth;
  }
}
